import { Button } from '@tecma/ds';
import emptySectionImage from 'assets/images/empty-section.svg';
import { useTranslation } from 'react-i18next';

import './empty-section.scss';

export const EmptySection = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation();
  return (
    <div className='empty-section'>
      <img src={emptySectionImage} alt='Empty section' />
      <h3 className='title'>{t('empty-section.title')}</h3>
      <span className='subtitle'>{t('empty-section.subtitle')}</span>
      <Button onClick={onClick} iconName='plus' outlined>
        {t('empty-section.button-label')}
      </Button>
    </div>
  );
};
